import { Dialog, Flag, Typography } from '@packages/shared';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { ServiceLayer } from '@packages/modules';
import { useTracking } from '@packages/tracking';
import { messages } from './messages';

const serviceLayerId = 'eco_delivery_co2neutral';

/**
 * EcoFriendlyDelivery component
 * */
export const EcoFriendlyDelivery = () => {
  const { formatMessage } = useIntl();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const dispatchGTMEvent = useTracking();

  useEffect(() => {
    dispatchGTMEvent({
      event: 'ga_event',
      eventAction: 'seen',
      eventLabel: 'detailview',
      eventValue: serviceLayerId,
    });
  }, [dispatchGTMEvent]);

  const clickHandler = () => {
    setIsModalOpen(true);
    dispatchGTMEvent({
      event: 'ga_event',
      eventAction: 'clicked',
      eventLabel: 'detailview',
      eventValue: serviceLayerId,
    });
  };

  return (
    <>
      <Typography
        variant="body2"
        component="div"
        role="button"
        onClick={clickHandler}
        sx={{ cursor: 'pointer', my: 0.5 }}
      >
        {formatMessage(messages.co2FriendlyText, {
          flag: (
            <Flag
              sx={{ color: 'common.white', top: '-0.1em' }}
              type="sustainability"
              text={formatMessage(messages.co2FriendlyFlag)}
            />
          ),
        })}
      </Typography>
      <Dialog
        open={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
        title={formatMessage(messages.dialogTitle)}
        dialogContent={<ServiceLayer serviceLayerId={serviceLayerId} />}
        displayTrackingProps={{ category: 'dv-service-layer-eco-friendly-delivery' }}
      />
    </>
  );
};
